import { DollarSign, Users } from 'lucide-react';

export const RECON_VISIBLE_KEY = 'adp-reconcile-element-recon-visible';

export const METRIC_GROUPS = [
  {
    title: 'Reconciliation',
    description: 'Element ↔ wage type variance',
    icon: DollarSign,
    metrics: [
      { key: 'exceptions', label: 'Exceptions', warn: true, value: (s) => s.exceptionCount },
      { key: 'matched', label: 'Matched pairs', value: (s) => s.comparisonStats?.match ?? s.matchedCount },
    ],
  },
  {
    title: 'Person coverage',
    description: 'Oracle person number vs ADP Global ID / Client ID',
    icon: Users,
    metrics: [
      { key: 'inBoth', label: 'In both systems', value: (s) => s.personPresence?.inBoth },
      {
        key: 'onlyOracle',
        label: 'Only in Oracle',
        warn: true,
        value: (s) => s.personPresence?.onlyOracleCount ?? s.personPresence?.onlyOracle,
      },
      {
        key: 'onlyAdp',
        label: 'Only in ADP',
        warn: true,
        value: (s) => s.personPresence?.onlyAdpCount ?? s.personPresence?.onlyAdp,
      },
      { key: 'oraclePersons', label: 'Oracle persons', value: (s) => s.personPresence?.oraclePersons },
    ],
  },
];

export function elementBreakdownTotal(row) {
  if (typeof row === 'number') return row;
  if (!row || typeof row !== 'object') return 0;
  return (
    (row.MissingInADP || 0) +
    (row.MissingInOracle || 0) +
    (row.AmountMismatch || 0) +
    (row.Unmapped || 0) +
    (row.HoursMismatch || 0) +
    (row.MissingInG2 || 0) +
    (row.MissingAdpHours || 0)
  );
}

export function flattenMetrics() {
  return METRIC_GROUPS.flatMap((g) => g.metrics);
}
